// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import SwalController from "./swal_controller"
application.register("swal", SwalController)

import TeamLogoController from "./team_logo_controller"
application.register("team-logo", TeamLogoController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import AdminDropdownController from "./admin_dropdown_controller"
application.register("admin-dropdown", AdminDropdownController)

import AgendaController from "./agenda_controller"
application.register("agenda", AgendaController)

import MatchTabsController from "./match_tabs_controller"
application.register("match-tabs", MatchTabsController)

import MatchClockController from "./match_clock_controller"
application.register("match-clock", MatchClockController)

import CompactScorebarController from "./compact_scorebar_controller"
application.register("compact-scorebar", CompactScorebarController)

import MomentumChartController from "./momentum_chart_controller"
application.register("momentum-chart", MomentumChartController)

import TooltipController from "./tooltip_controller"
application.register("tooltip", TooltipController)

import StatsToggleController from "./stats_toggle_controller"
application.register("stats-toggle", StatsToggleController)

import VideoEmbedController from "./video_embed_controller"
application.register("video-embed", VideoEmbedController)

import MatchAutocompleteController from "./match_autocomplete_controller"
application.register("match-autocomplete", MatchAutocompleteController)

import XgChartController from "./xg_chart_controller"
application.register("xg-chart", XgChartController)

